import {
    AUTH_UPDATE_TABLE_DEFINITION_SAGA,
    AUTH_WITH_CREDENTIALS_SAGA,
} from "@/Redux/Auth/AuthConstants";

export const authWithCredentials = (
    username: string,
    password: string,
    callback: (err: Error) => void,
) => {
    return {
        type: AUTH_WITH_CREDENTIALS_SAGA,
        payload: {
            username,
            password,
            callback,
        },
    };
};

export const updateTableDefinition = (
    data: string,
    gridName: string,
    formName: string,
    callback: (err: Error) => void,
) => {
    return {
        type: AUTH_UPDATE_TABLE_DEFINITION_SAGA,
        payload: {
            data,
            gridName,
            formName,
            callback,
        },
    };
};
